import React from 'react';
import { useSelector } from 'react-redux';

import SettingsForm from './SettingsForm';
import RightPane from './RightPane';

import { isFrequencyOrContingencyTable } from 'store/dataset';

const InferentialStatistics = () => {

  const isFrequencyOrContingency = useSelector(state => isFrequencyOrContingencyTable(state));

  return (
    <div className="page-main__indent">
      <div className="flex">
        <div className="settings-width mb-15 mr-15">
          <SettingsForm isFrequencyOrContingency={isFrequencyOrContingency} />
        </div>

        <div id="right-pane" className="graph-width mb-15">
          <RightPane isFrequencyOrContingency={isFrequencyOrContingency} />
        </div>
      </div>
    </div>
  );
};

export default InferentialStatistics;
